import { sortBy } from "lodash-es";
export function peopleNameSort(people) {
    return sortBy(people, ["lastName", "firstName"]);
}
/**
 * Utility to sort registration's first athlete in order by lastName then firstName
 * @param registrations
 * @returns registration sorted by first athlete's lastName and firstName
 */
export function registrationsAthleteNameSort(registrations) {
    return sortBy(registrations, [
        "athletes[0].lastName",
        "athletes[0].firstName"
    ]);
}
